import DOMPurify from 'isomorphic-dompurify'

/**
 * An email's HTML made safe to preview: scripts, event handlers (onclick,
 * onerror) and javascript: links are removed, while what makes it look like
 * the email a recipient gets stays: the <head> styles and media queries, the
 * <body> attributes, inline styles, images, and the ${variable} placeholders,
 * which show as written.
 *
 * Shown in EmailFrame (components/TemplateRenderer), whose sandbox already
 * runs no script; this also keeps a model-written email (the Template Writer)
 * from carrying any. A missing body previews as an empty email.
 */
export const emailPreviewHtml = (html) =>
    DOMPurify.sanitize(html ?? '', { WHOLE_DOCUMENT: true })

export default emailPreviewHtml
